/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detailsForm.vue?vue&type=template&id=42d95730&scoped=true"
import script from "./detailsForm.vue?vue&type=script&lang=js"
export * from "./detailsForm.vue?vue&type=script&lang=js"
import style0 from "./detailsForm.vue?vue&type=style&index=0&id=42d95730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d95730",
  null
  
)

export default component.exports